module.exports = __webpack_public_path__ + "media/images/top/icon/gray/ico_dot-ce7c61c04184536f537ec2f56def4ff3.svg";